import React, {useRef} from 'react';
import {useDispatch} from 'react-redux';

import {selectApplication} from 'modules/applications/actions';

import Title from 'components/Text/Title';

export default function AppCard(props) {

    const {app} = props;
    const dispatch = useDispatch();

    const padding = 20;

    const imageSize = 150;

    const cardStyles = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: imageSize + 30,
        borderRadius: padding,
        borderWidth: 3,
        borderStyle: 'solid',
        borderColor: '#a4c2b8',
        padding: padding,
        marginLeft: 10,
        marginRight: 10,
    };

    const imageStyles = {
        width: imageSize,
        height: imageSize,
        display: 'block',
        marginBottom: 15,
    };

    const selectApp = (e) => {
        e.preventDefault();
        dispatch(selectApplication(app.id));
    }

    let CardContent = <button onClick={selectApp}>
        <img style={imageStyles} src={app.image.card} alt={app.name}/>
        <Title level={3}>{app.name}</Title>
    </button>;

    if (app.type == 'external') {

        const ref = useRef(null);

        const toggleHover = hover => {
            if (ref.current) {
                ref.current.style.backgroundColor = hover ? '#012' : '';
                ref.current.style.color = hover ? '#eee' : '#bbb';
            }

        };

        const linkStyles = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textDecoration: 'none',
            color: '#bbb',
        };
        CardContent = <a
            href={app.link}
            style={linkStyles}
            ref={ref}
            onMouseOver={() => toggleHover(true)}
            onMouseOut={() => toggleHover(false)}
        >
            {CardContent}
        </a>;
    }

    return <section style={cardStyles}>
        {CardContent}
    </section>;

}